module.exports = __webpack_public_path__ + "media/images/facebook-ce052b1b36bef634ee00778ab02b9f20.svg";